import { Airport } from './airport';
import { MobileBaseObject } from './mobile-base-object';
import { List } from "immutable";

export interface ILocation extends MobileBaseObject {
  name: string;
  type: string;
  airportID: string;
  areas: string;
  geoFence: string;
  description: string;
  weekDayOpens: string;
  weekDayCloses: string;
  weekEndOpens: string;
  weekEndCloses: string;
  defaultETATransfer: string;
  status: string;
}


export class Location extends MobileBaseObject implements ILocation {

  public name: string;
  public type: string;
  public airportID: string;
  public areas: string;
  public geoFence: string;
  public description: string;
  public weekDayOpens: string;
  public weekDayCloses: string;
  public weekEndOpens: string;
  public weekEndCloses: string;
  public defaultETATransfer: string;
  public status: string;

  public constructor(
    location: Partial<ILocation>

  ) {
    super();

    if (location != null) {
      this.name = location.name;
      this.type = location.type;
      this.airportID = location.airportID;
      this.areas = location.areas;
      this.geoFence = location.geoFence;
      this.description = location.description;
      this.weekDayOpens = location.weekDayOpens;
      this.weekDayCloses = location.weekDayCloses;
      this.weekEndOpens = location.weekEndOpens;
      this.weekEndCloses = location.weekEndCloses;
      this.defaultETATransfer = location.defaultETATransfer;
      this.status = location.status;

      this.id = location.id;
      this.version = location.version;
      this.createdAt = location.createdAt;
      this.updatedAt = location.updatedAt;
      this.version = location.version;
    }
  }

  public get areasExpanded(): string[] {
    return JSON.parse(this.areas) as string[];
  }
  public set areasExpanded(value: string[]) {
    this.areas = JSON.stringify(value);
  }

}
